import {
    FOREIGN_ACCOUNT_COUNTRY_MISMATCH_REASON,
    getForeignAccountCountryMismatchReason,
} from "pages/frequentDestination/validation/foreignAccountCountryValidation";

/** Shared modal reasons: IBAN mismatch vs TPH incomplete address details. */
export const BENEFICIARY_MODAL_REASON = {
    IBAN_REQUIRED: FOREIGN_ACCOUNT_COUNTRY_MISMATCH_REASON.IBAN_REQUIRED,
    INCOMPLETE_DETAILS: "INCOMPLETE_DETAILS",
};

export const isIncompleteBeneficiaryDetails = (extraDataMap = {}) => {
    const { buildingFloor, buildingName, city, country, address, province, accountType } = extraDataMap;
    const emptyProvince = !province?.value;
    return !country || emptyProvince || !city || !buildingFloor || !buildingName || !address || !accountType;
};

/**
 * Decides if selecting a preloaded beneficiary should open the update modal.
 * TPH incomplete details win over IBAN_REQUIRED: an outdated beneficiary must be
 * completed first, and that edit already covers the account type. Requires idBeneficiary.
 *
 * @returns {{ reason: string, idBeneficiary: string } | null}
 */
export const resolveBeneficiaryModalReason = (
    extraDataMap,
    { isDetailedVersion = false, configUtils, idBeneficiary } = {},
) => {
    if (!idBeneficiary) {
        return null;
    }

    const data = extraDataMap || {};

    if (isDetailedVersion && isIncompleteBeneficiaryDetails(data)) {
        return { reason: BENEFICIARY_MODAL_REASON.INCOMPLETE_DETAILS, idBeneficiary };
    }

    const ibanReason = getForeignAccountCountryMismatchReason(data, configUtils);
    if (ibanReason === FOREIGN_ACCOUNT_COUNTRY_MISMATCH_REASON.IBAN_REQUIRED) {
        return { reason: BENEFICIARY_MODAL_REASON.IBAN_REQUIRED, idBeneficiary };
    }

    return null;
};
